module.exports = __webpack_public_path__ + "static/media/alert.2db881f4.svg";